export const GET_DANH_SACH_DON_HANG = 'GET_DANH_SACH_DON_HANG';
export const GET_DANH_SACH_DON_HANG_DONE = 'GET_DANH_SACH_DON_HANG_DONE';

export const UPDATE_STATUS_ORDER = 'UPDATE_STATUS_ORDER';

export const GET_TOTAL_QUAN_LY_DON_HANG = 'GET_TOTAL_QUAN_LY_DON_HANG';
export const GET_TOTAL_HEADER_QUAN_LY_DON_HANG = 'GET_TOTAL_HEADER_QUAN_LY_DON_HANG';

export const GET_LIST_CHAT_IN_BILL = 'GET_LIST_CHAT_IN_BILL';
export const POST_CHAT_IN_BILL = 'POST_CHAT_IN_BILL';